
import lazyInject from '@/di';
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { BASE_URL } from '@/common/constant';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import UserService from '@/services/user.service';
import { BrandService } from '@/services/brand_service';
import { component as Viewer } from 'v-viewer';
import { Brand } from '@/models/brand.model';


@Component({
  components: {
    Viewer,
  },
})
export default class EditBrandModal extends Vue {
  uploading = false;

  BASE_URL = BASE_URL;

  titleName = '新增品牌';

  oldImages = '';

  isLoading = false;

  isVisible = false;

  token: string | undefined = undefined;

  fileList: Array<{
    id: number;
    uid: any;
    name: any;
    status: any;
    url: string;
  }> = [];

  imageListId: any = [];

  form = {
    name: '',
    primaryAccount: '',
    brandAdmin: '',
    brandcode: '',
    prodLink: '',
    logo: '',
    withdrawal_account_name: '',
    withdrawal_account: '',
    headlineImage: { id: 0, url: '' },
    id: undefined as number | undefined,
  };

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  rules = {
    name: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }],
    primaryAccount: [
      { required: true, message: '请输入主账号', trigger: 'blur' },
    ],
    brandAdmin: [
      {
        required: true,
        message: '请输入品牌管理员账号，需要与主账号不一致',
        trigger: 'blur',
      },
    ],
    brandcode: [
      { required: true, message: '请输入brandcode', trigger: 'blur' },
    ],
    logo: [{ required: true, message: '请输入品牌logo链接', trigger: 'blur' }],
    headlineImage: [
      {
        validator: this.headlineImageValidator,
        message: '请上传品牌头图',
        trigger: 'blur',
      },
      // {
      //   validator: this.headlineImagesValidator,
      //   message: '上传品牌相册图片不能小于3张',
      //   trigger: 'blur',
      // },
    ],
    withdrawal_account: [
      {
        validator: (rule: any, value: string) => {
          if (!value) {
            return Promise.resolve();
          }
          const alipayPattern = /^(?:1[3-9]\d{9}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
          if (!alipayPattern.test(value)) {
            return Promise.reject('请输入正确的支付宝账号(手机号或邮箱)');
          }
          return Promise.resolve();
        },
        trigger: 'blur',
      },
    ],
  };

  @Ref()
  readonly ruleForm!: FormModel;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @lazyInject(UserService)
  protected userService!: UserService;

  get getId() {
    console.log(this.form.id);
    return this.form.id !== undefined;
  }

  headlineImageValidator() {
    if (this.fileList.length > 0) {
      return true;
    }
    return false;
  }

  headlineImagesValidator() {
    if (this.fileList.length >= 3) {
      return true;
    }
    return false;
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }
  async onRemove(v: any) {
    console.log(v);
  }

  /**
 * 设为头图
 */
  setHeadImg(index: number) {
    console.log(index);
    const idList = this.fileList.map((item) => item.id);
    const head = idList.splice(index, 1);
    idList.unshift(head[0]);
    const fileList: any = [];
    idList.forEach((item) => {
      this.fileList.forEach((res) => {
        if (item == res.id) {
          fileList.push(res);
        }
      });
    });
    this.fileList = fileList;
  }
  /**
   * 左移
   */
  setHeadImgLeft(index: number) {
    console.log(index);
    const idList = this.fileList.map((item) => item.id);
    const targetId = idList.splice(index, 1)[0];
    idList.splice(index - 1, 0, targetId);
    const fileList: any = [];
    idList.forEach((item) => {
      this.fileList.forEach((res) => {
        if (item == res.id) {
          fileList.push(res);
        }
      });
    });
    this.fileList = fileList;
  }

  /**
   * 右移
   */
  setHeadImgRight(index: number) {
    console.log(index);
    const idList = this.fileList.map((item) => item.id);
    const targetId = idList.splice(index, 1)[0];
    idList.splice(index + 1, 0, targetId);
    const fileList: any = [];
    idList.forEach((item) => {
      this.fileList.forEach((res) => {
        if (item == res.id) {
          fileList.push(res);
        }
      });
    });
    this.fileList = fileList;
  }

  /**
   * 删除店铺图片
   */
  delShopImg(index: number) {
    // if (this.fileList.length < 4) {
    //   this.$message.error('店铺相册图片不能小于3张');
    // } else {
      const idList = this.fileList.map((item) => item.id);
      idList.splice(index, 1);
      this.fileList.splice(index, 1);
    // }
  }
  async onChange(info: any) {
    console.log(info);
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      this.fileList.push(headlineImage);
      // console.log(this.fileList);
      this.$set(this.form, 'headlineImage', headlineImage);
      this.uploading = false;
    }
    if (info.file.status === 'removed') {
      if (info.file.xhr) {
        const { data } = JSON.parse(info.file.xhr.response);
        const id = data[0]?.id;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      } else {
        console.log(info.file);
        const { id } = info.file;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      }
    }
  }

  async submit() {
    this.fileList.forEach((element: { id: any }) => {
      if (!this.imageListId.includes(element.id)) {
        this.imageListId.push(element.id);
      }
    });
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;
        try {
          if (this.getId) {
            const {
              name,
              primaryAccount,
              brandAdmin,
              brandcode,
              logo,
              prodLink,
              withdrawal_account_name,
              withdrawal_account,
            } = this.form;

            const brandData: {
              ka_id: number;
              old_images?: string;
              new_images?: string;
              name: string;
              owner_id: any;
              brand_code: any;
              staff_id: any;
              header_pic: any;
              logo: any;
              webhook_url: any;
              withdrawal_account_name: any;
              withdrawal_account: any;
            } = {
              ka_id: this.form.id!,
              old_images: this.oldImages,
              new_images: this.imageListId.join(','),
              name,
              owner_id: primaryAccount,
              brand_code: brandcode,
              staff_id: brandAdmin,
              header_pic: this.imageListId.join(','), // Add this line
              logo,
              webhook_url: prodLink || '',
              withdrawal_account_name: withdrawal_account_name || undefined,
              withdrawal_account: withdrawal_account || undefined,
            };
            if (this.oldImages === this.imageListId.join(',')) {
              delete brandData.old_images;
              delete brandData.new_images;
            }
            const res = await this.brandService.updateBrand(brandData);
            if (res) {
              this.$message.success(res);
              this.$emit('refresh');
              await $delay(500);
              this.close();
            }
          } else {
            const {
              name,
              primaryAccount,
              brandAdmin,
              brandcode,
              logo,
              prodLink,
              withdrawal_account_name,
              withdrawal_account,
            } = this.form;
            const res = await this.brandService.create({
              name,
              owner_id: primaryAccount,
              brand_code: brandcode,
              staff_id: brandAdmin,
              header_pic: this.imageListId.join(','),
              logo,
              webhook_url: prodLink || '',
              withdrawal_account_name,
              withdrawal_account,
            });
            if (res) {
              this.$message.success(res);
              this.$emit('refresh');
              await $delay(500);
              this.close();
            }
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
        }
      }
    });
  }

  reset() {
    this.form = {
      name: '',
      primaryAccount: '',
      brandAdmin: '',
      brandcode: '',
      prodLink: '',
      logo: '',
      withdrawal_account_name: '',
      withdrawal_account: '',
      headlineImage: { id: 0, url: '' },
      id: undefined as number | undefined,
    };
    this.fileList = [];
    if (this.isLoading) {
      this.isLoading = false;
    }
    this.ruleForm.resetFields();
  }

  async open(val: any) {
    this.fileList = [];
    this.imageListId = [];
    if (val) {
      const data = await this.brandService.brandDetail(val.id);
      const d = JSON.parse(JSON.stringify(Brand.from(data)));
      console.log(d);
      this.form = d;
      this.fileList = d.headerPic;
      interface resD {
        uid: any;
        id: any;
        name: any;
        status: any;
      }
      const oldImages: number[] = [];
      this.fileList.forEach((res: resD) => {
        oldImages.push(res.id);
        res.uid = res.id;
        res.name = 'mage.png';
        res.status = 'done';
        res.uid = res.id;
      });
      this.oldImages = oldImages.join(',');
      this.titleName = '修改品牌';
    } else {
      this.form = {
        name: '',
        primaryAccount: '',
        brandAdmin: '',
        brandcode: '',
        prodLink: '',
        logo: '',
        withdrawal_account_name: '',
        withdrawal_account: '',
        headlineImage: { id: 0, url: '' },
        id: undefined as number | undefined,
      };
      this.fileList = [];
      this.titleName = '新增品牌';
    }
    setTimeout(() => {
      this.isVisible = true;
    }, 100);
  }

  close() {
    this.isVisible = false;
    this.reset();
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }
}
